import styled from 'styled-components'

const StyledForm = styled.form`
	display: grid;
	grid-gap: 3rem;
	grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
	margin-top: 5rem;
	button {
		grid-column-end: -1;
		justify-self: end;
	}
`

export { StyledForm }
